import request from "./request";
import { serializeQueryParams } from "./helper";
import { IRequest } from "@/shared/types/request";
import {
  IExperiments,
  IExperiment,
  IMatrixSignificance,
} from "@/shared/types/experiments";

export const getExperiments = (url?: string) =>
  request.get<never, IRequest<IExperiments>>(url || "/experiments");

export const getStatistics = (params: {
  experiment_id: number;
  created_at: string;
  environment: string;
}) => request.get(`/experiments-statistics`, { params });

export const getStatisticSignificance = (params: {
  experiment_id: number;
  environment: string;
}) =>
  request.get<never, IRequest<IMatrixSignificance>>(
    `/statistics/significance`,
    { params }
  );

export const createExperiments = (field: IExperiment) =>
  request.post<never, IRequest<IExperiment>>(
    `/experiments`,
    getFormData(field)
  );

export const editExperiments = ({
  id,
  field,
}: {
  id: number;
  field: IExperiment;
}) =>
  request.put<never, IRequest<IExperiment>>(
    `/experiments/${id}${serializeQueryParams(field)}`
  );

export const toggleExperiment = (id: number) =>
  request.put<never, IRequest<IExperiment>>(`/toggle-experiment/${id}
`);

export const resetStatistics = (payload: {
  experiment_id: number;
  environment: string;
}) =>
  request.post<never, IRequest<string>>(
    `/reset-statistics`,
    getFormData(payload)
  );

export const updateExperiments = ({
  id,
  field,
}: {
  id: number;
  field: IExperiment;
}) =>
  request.patch<never, IRequest<IExperiment>>(
    `/update-experiments/${id}
`,
    field
  );

export const deleteExperiments = (id: number) =>
  request.delete<never, IRequest<string>>(`/experiments/${id}
  `);

function getFormData(obj: any) {
  const data = new FormData();
  for (const prop in obj) {
    if (Array.isArray(obj[prop]) || obj[prop] instanceof FileList) {
      Array.from(obj[prop]).forEach((item, index) => {
        if (typeof item === "number") {
          data.append(`${prop}[${index}]`, String(item));
        } else if (item instanceof File) {
          data.append(`${prop}[${index}]`, item);
        }
      });
    } else {
      data.append(prop, obj[prop]);
    }
  }
  return data;
}
